/**
 * Причина отклонения заявки на карту.
 */
export enum CardOrderCancelReason {
    /**
     * Клиент запретил доступ к персональным данным в системе аутентификации
     */
    PERSONAL_DATA_ACCESS_FORBIDDEN = 'PERSONAL_DATA_ACCESS_FORBIDDEN',

    /**
     * Клиент обнаружил, что его персональные данные, полученные из системы аутентификации, не верные.
     */
    PERSONAL_DATA_INVALID = 'PERSONAL_DATA_INVALID',

    /**
     * Клиент продолжил ранее созданную заявку
     */
    PROCEED_CREDIT_CARD_ORDER = 'PROCEED_CREDIT_CARD_ORDER',

    /**
     * Клиент запросил консультацию
     */
    CONSULTATION_REQUIRED = 'CONSULTATION_REQUIRED',
}
